import Cookies from "js-cookie";

let warnGlobalCookiesUsage = true;
// tmp fix for scripts that should import Cookies instead of use global property. Note: some page have inlined JS that use it too
Object.defineProperty(window, "Cookies", {
  get: () => {
    if(warnGlobalCookiesUsage){
      console.warn("Use global Cookies is depreciated, use 'import Cookies from \"js-cookie\";' instead.");
    }
    warnGlobalCookiesUsage = false;
    return Cookies;
  }
});
